export class UserAttribute {
    Name: string;
    Value: string;

    public constructor(n: string, v: any) {
        this.Name = n;
        this.Value = v.toString();
    }
}